import React from 'react';
import { Route, Switch } from 'react-router-dom';
import * as Auth from '../../auth/';
import { MainLayout } from '../../main';

import Spinner from '../../../common/components/misc/Spinner';
import AuthWrapperContainer, { AuthWrapperContainerProps } from './containers/AuthWrapperContainer';

const AuthWrapper: React.FC<AuthWrapperContainerProps> = (containerProps) => (

    <AuthWrapperContainer {...containerProps}>
        {(props) => {
            if (props.isReadyToRender) {
                return (
                    <Switch>
                        <Route path={[`${props.config.BaseURL}/auth/gcdm/:formid/:redirectParent/:src+`, `${props.config.AlternativeBaseURL}/auth/gcdm/:formid/:redirectParent/:src+`]} component={Auth.LoginWithGCDM} />
                        <Route path={[`${props.config.BaseURL}/auth/gcdm/:formid/:redirectParent`, `${props.config.AlternativeBaseURL}/auth/gcdm/:formid/:redirectParent`]} component={Auth.LoginWithGCDM} />
                        <Route path={[props.config.BaseURL, props.config.AlternativeBaseURL]} component={MainLayout} />
                    </Switch>
                );
            }
            return (
                <Spinner />
            );
        }}
    </AuthWrapperContainer>
);

export default AuthWrapper;
